import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoMantenimiento from "../servicios/InfoMantenimiento";
const Footer = lazy(() => import('../footer/Footer'));
function Mantenimiento(props) {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="En Hyundai garantizamos tu inversión y el óptimo funcionamiento de tu vehículo. Utilizamos solo repuestos genuinos y mano de obra calificada"
        />
        <meta name="keywords" content="mantenimiento Hyundai" />
        <title>Mantenimiento Hyundai</title>
      </Helmet>
      <Menu />
      <InfoMantenimiento datos={props} />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Mantenimiento;